/* eslint-disable arrow-body-style */
/**
 * 公共接口
 */

import http from './utils';
import { mockPrefix, prefix } from './constants';
import axios from 'axios';
const CancelToken = axios.CancelToken;
export const getOpinionFilterCond: (payload: any) => Promise<any> | any = (
  payload,
) => {
  return http({
    url: `${prefix}/filter/cond`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const deleteFilterSettingById: (payload: any) => Promise<any> | any = (
  payload,
) => {
  return http({
    url: `${prefix}/filter/delete`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const getFilterSettingListByGame: (
  payload: any,
) => Promise<any> | any = (payload) => {
  return http({
    url: `${prefix}/filter`,
    method: 'post',
    data: payload,
    errorHandler: true,
  }) as Promise<any>;
};

export const checkFilterSetting: (payload: any) => Promise<any> | any = (
  payload,
) => {
  return http({
    url: `${prefix}/filter/check`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const addFilterSetting: (payload: any) => Promise<any> | any = (
  payload,
) => {
  return http({
    url: `${prefix}/filter/add`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const createShortUrl: (
  payload: any,
  cancelTokenFunc?: any,
) => Promise<any> | any = (payload, cancelTokenFunc = () => {}) => {
  return http({
    url: `${prefix}/short/url/create`,
    method: 'post',
    data: payload,
    errorHandler: true,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<any>;
};

export const getShortUrlInfo: (payload: any) => Promise<any> | any = (
  payload,
) => {
  return http({
    url: `${prefix}/short/url/get`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export function getShortUrlParse(id: string) {
  if (!id) return {};

  return getShortUrlInfo({ short_url: id })
    .then((data: any) => {
      if (data) {
        return JSON.parse(data);
      }
      return {};
    })
    .catch(() => {
      return {};
    });
}
